var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Box',_vm._b({staticClass:"c_flex",class:_vm.flexClasses,style:(_vm.flexStyles),attrs:{"element-type":_vm.elementType}},'Box',_vm.box,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }